import React, { useEffect } from "react";
import { Heading } from "../../design/heading";
import { useParams } from "react-router-dom";
import EventSubtypesList from "./components/EventTypesList";
import EventCategoryEventsList from "./components/EventCategoryEventsList";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import Breadcrumbs from "../../components/Breadcrumbs";
import { useEventType } from "../../contexts/EventTypeContext";
import EventCategoryButton from "../../components/EventCategoryButton";

const EventCategoryDetailPage: React.FC = () => {
  const { eventCategoryId } = useParams<{ eventCategoryId: string }>();
  const { eventCategories, error, loading } = useEventType();

  if (loading.details) {
    return <LoadingView title="Loading Event Category..." />;
  }

  if (error.details) {
    return <ErrorView error={error.details} />;
  }

  const eventCategory = eventCategories.find(
    (type) => type._id === eventCategoryId,
  );

  return (
    <div className="container p-4 mx-auto lg:p-8">
      <Breadcrumbs
        items={[
          { label: "Event Categories", href: "/event-categories" },
          {
            label: eventCategory?.name ?? "Event Category",
            href: `/event-type/${eventCategoryId}`,
          },
        ]}
      />

      <div className="mb-6">
        <div className="flex items-center justify-between">
          <Heading>{eventCategory?.name}</Heading>
          <div className="flex gap-2">
            {eventCategory && (
              <EventCategoryButton eventCategory={eventCategory} />
            )}
          </div>
        </div>

        <EventSubtypesList eventCategoryId={eventCategoryId!} />
        <EventCategoryEventsList eventCategoryId={eventCategoryId!} />
      </div>
    </div>
  );
};

export default EventCategoryDetailPage;
